import React, { Component,useRef,useState } from 'react';
import NoImage from './combined-shape.svg';
import IconUploadWhite from './icon_upload_white.svg';

const  UploadButton = (props) => {
  console.log("propshjgfadhjasgfdahs",props)

  // state = {
  //   selectedImage: [],
  //   maxFileSize: false,
  // }

  const [selectedImage, setSelectedImage] = useState([]);
  const [maxFileSize, setMaxFileSize] = useState(false);
  const [fileName, setFileName] = useState('');
  let inputRef = useRef('');

  const compress = (e) => { 
    console.log(e);
    return new Promise((resolve, reject) => {
      const fileName = e.name;
      const reader = new FileReader();
      reader.readAsDataURL(e);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const elem = document.createElement('canvas');
          const imgWidth = img.width;
          const width = (imgWidth / 100) * 75;
          // const size = img.size / 1024 / 1024;
          const scaleFactor = width / imgWidth;
          elem.width = width;
          elem.height = img.height * scaleFactor;
          const ctx = elem.getContext('2d');
          ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          ctx.canvas.toBlob((blob) => {
            const file = new File([blob], fileName, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            resolve(file);
          }, 'image/jpeg', 0.75);
        };

        reader.onerror = error => reject(error);
      };
    });
  }

  // fireGaEvent = () => {
  //   value = null;
  // };

  const handleChange = async () => {
    console.log('file..........');
    console.log("props././././",props)

    // const { props } = this;
    // const fileType = inputRef.files &&
    // inputRef.files[0].name.split('.')[1].toLowerCase();
    const fileType = inputRef.files && inputRef.files[0].name.substring(inputRef.files[0].name.lastIndexOf('.') + 1, inputRef.files[0].name.length);
    // const { user } = props;
    // console.log('inputRef.files[0].size', inputRef.files[0].size / 1024 / 1024);
    const maxSize = 10;
    // const targetUrl = `${user._links.business.href}/proof_of_payments`;
    const validFileTypes = ['png', 'gif', 'jpg', 'jpeg', 'csv', 'xls', 'pdf',
      'doc', 'docx', 'xlsx', 'PDF', 'PNG', 'JPG', 'JPEG', 'XLS', 'XLSX', 'GIF'];
    const validImagetypes = ['png', 'gif', 'jpg', 'jpeg', 'JPG', 'PNG'];
    if (((inputRef.files[0].size / 1024 / 1024) > maxSize)) {
      inputRef.value = '';
      // setState({
      //   maxFileSize: true
      // });
      setMaxFileSize(true)
      props.onInvalidFileSize();
    } else if (validFileTypes.indexOf(fileType) > -1) {
      if (inputRef.files[0]) {
        let compressed = inputRef.files[0];
        if (validImagetypes.indexOf(fileType) > -1) {
          compressed = await compress(inputRef.files[0]);
        }
        // const formData = new FormData();
        // formData.append('file_url', compressed);


        const reader = new FileReader();
        const file = inputRef.files[0];
        reader.onloadend = () => {
          // setState({
          //   selectedImage: reader.result,
          //   fileName: file.name,
          //   maxFileSize: false,
          // });
          setSelectedImage(reader.result);
          setMaxFileSize(false);
          setFileName(file.name);
        };
        reader.readAsDataURL(file);

        props.selectedFile(compressed);
      }
    } else {
      inputRef.value = '';
      // setState({
      //   selectedImage: [],
      //   fileName: '',
      // });
      setSelectedImage([]);
          setFileName('');
      props.onInvalidFileSubmit();
    }
  };

 
    // const { props, state } = this;
    return (
      <div className={props.uploading ? 'screen-disable' : ''}>
        <div className="pop-upload-button">
          <label>Upload Images<sup className="asterisk">*</sup></label>
          <div className="upload-button-wrapper">
            <input
              id="myfile"
              type="file"
              accept=".xlsx,.xls, .png, .jpg, .jpeg, .doc, .docx,.ppt, .pptx,.txt,.pdf"
              name="myfile"
              onChange={handleChange}
            //   onClick={fireGaEvent}
              ref={(ref) => { inputRef = ref; }}
            />
          </div>
          {
            selectedImage.length > 0 && !maxFileSize &&
            <div className="complaint-multiple-uploads">
              <img src={selectedImage.includes('data:image/') ? selectedImage : NoImage} alt="" />
              <div>{fileName}</div>
              {/* <i className="icon-delete" onClick={() => { showDelConfirmPop(index); }} />
               */}
            </div>
          }
        </div>
      </div>
    );
  
}

export default UploadButton;
